import { Injectable } from '@angular/core';


export class SeedService {

	constructor() { }

	sayHello() {
		return "Hello!";
	}

static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
